import { z } from "zod";
import { BaseSchema, LanguageEnum } from "../common";

const ProjectTranslationValueSchema = z.object({
  title: z
    .string()
    .trim()
    .min(3)
    .max(255)
    .refine((value) => value.toLowerCase() !== "n/a", "Enter a real translation title"),
  overview: z
    .string()
    .trim()
    .min(3)
    .refine((value) => value.toLowerCase() !== "n/a", "Enter real translated content"),
  metaTitle: z.string().trim().optional(),
  metaDescription: z.string().trim().optional(),
  slug: z.string().trim().min(1).nullable().optional(),
  publicationStatus: z.enum(["draft", "published"]).optional(),
});

export const ProjectTranslationSchema = z.object({
  ...BaseSchema.shape,
  lang: LanguageEnum,
  title: z.string(),
  overview: z.string(),
  metaTitle: z.string().nullable().optional(),
  metaDescription: z.string().nullable().optional(),
  slug: z.string().nullable().optional(),
  publicationStatus: z.enum(["draft", "published"]),
  projectId: z.uuidv7(),
});

export const ProjectTranslationsSchemas = {
  list: ProjectTranslationSchema,
  save: ProjectTranslationValueSchema.extend({
    lang: LanguageEnum,
    projectId: z.uuidv7(),
  }),
  update: ProjectTranslationValueSchema.extend({
    id: z.uuidv7(),
    lang: LanguageEnum,
    projectId: z.uuidv7(),
  }),
  delete: z.object({ id: z.uuidv7() }),
};

export type SaveProjectTranslation = z.infer<typeof ProjectTranslationsSchemas.save>;
